const prefix = '_settings.'

const state = {
  locale: localStorage.getItem(prefix + 'locale') || 'en'
}

const mutations = {
  setLocale (state, payload) {
    state.locale = payload

    localStorage.setItem(prefix + 'locale', payload)
  }
}

const actions = {
  setLocale ({ commit }, locale) {
    commit('setLocale', locale)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js